module.exports = __webpack_public_path__ + "static/media/20ECE7.6d2bcf86.jpg";